import { QueryKeys } from '../../../queryKeys';
import { getRequest } from '../../../helpers/apiClient';
import apiRoutes from '../../../api-routes';
import { useQueryWithLogout } from '../../../hooks/useQueryWithLogout';

export const useSingleUser = (options) => {
  return useQueryWithLogout(
    [QueryKeys.SINGLE_USER, options.id],
    async () => {
      const { data } = await getRequest({
        url: apiRoutes.SINGLE_USER.replace('{id}', options?.id),
      });

      return data;
    },
    options,
  );
};
